var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36784 0C5.36568 0 6.32265 0.391325 7.02823 1.08789C7.73381 1.78445 8.1302 2.7292 8.1302 3.71429C8.1302 4.63429 7.7887 5.48 7.22723 6.13143L7.38352 6.28571H7.84079L10.7349 9.14286L9.86668 10L6.97255 7.14286V6.69143L6.81627 6.53714C6.15641 7.09143 5.29975 7.42857 4.36784 7.42857C3.36999 7.42857 2.41302 7.03725 1.70744 6.34068C1.00186 5.64412 0.605469 4.69938 0.605469 3.71429C0.605469 2.7292 1.00186 1.78445 1.70744 1.08789C2.41302 0.391325 3.36999 0 4.36784 0ZM4.36784 1.14286C2.92077 1.14286 1.76312 2.28571 1.76312 3.71429C1.76312 5.14286 2.92077 6.28571 4.36784 6.28571C5.8149 6.28571 6.97255 5.14286 6.97255 3.71429C6.97255 2.28571 5.8149 1.14286 4.36784 1.14286Z",
    fill: "#234BA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilter);
export default __webpack_public_path__ + "static/media/searchFilter.435b8fd39a4071e500d7edc44e721603.svg";
export { ForwardRef as ReactComponent };